import React, { useRef } from 'react'

import { HeaderNav, MapStrapiComponentToSubMenuType, subMenuType } from '@application/Types/HeaderTypes'
import { Link } from '@src/Application/Interfaces/Atoms/Link'
import { DynamicColumnSubMenu } from '@src/Application/Interfaces/Features/Header/Nav/DynamicColumnSubMenu'
import { HeaderThemeModeType } from '@src/Application/Types/ComponentTypes'
import { handleDeferredRedirect, isPopeyeUrl } from '@src/Application/Utils/BrowserUtils'

import { NavItem, NavItemButton, NavItemLink, NavItemLinkLabel, SubMenuWrapper } from './Nav.styled'
import { ThreeColumnSubMenu } from './ThreeColumnSubMenu'
import { TwoColumnSubMenu } from './TwoColumnSubMenu'
import { positionSubmenu } from './utils'

export const NavItemElement = ({
    index,
    node,
    mode,
}: {
    index: number
    node: HeaderNav
    mode: HeaderThemeModeType
}): JSX.Element => {
    const submenuRef = useRef(null)
    const clickedRef = useRef(false)

    const handleClickProps = isPopeyeUrl(node.link) ? { onClick: handleDeferredRedirect(node.link, clickedRef) } : {}

    return (
        <NavItem key={`desktop-nav-${index}`} onMouseEnter={positionSubmenu(submenuRef)}>
            {(!node.submenu || Boolean(node.submenu.length === 0)) && node.linkStyle !== 'button' && (
                <NavItemLink to={node.link} {...handleClickProps}>
                    {node.label}
                </NavItemLink>
            )}
            {(!node.submenu || Boolean(node.submenu.length === 0)) && node.linkStyle === 'button' && (
                <Link to={node.link} {...handleClickProps}>
                    <NavItemButton size="small" mode={mode === 'Dark' ? 'Dark' : 'Light'}>
                        {node.label}
                    </NavItemButton>
                </Link>
            )}
            {node.submenu && Boolean(node.submenu.length > 0) && <NavItemLinkLabel>{node.label}</NavItemLinkLabel>}
            {node.submenu?.map((sub, j) => {
                const type = MapStrapiComponentToSubMenuType[sub.strapi_component]
                return (
                    <SubMenuWrapper key={sub.id} type={type} ref={submenuRef}>
                        {type === subMenuType['two-columns-submenu'] && <TwoColumnSubMenu {...sub} />}
                        {type === subMenuType['three-columns-submenu'] && <ThreeColumnSubMenu {...sub} />}
                        {type === subMenuType['dynamic-columns'] && <DynamicColumnSubMenu {...sub} />}
                    </SubMenuWrapper>
                )
            })}
        </NavItem>
    )
}
